module.exports = __webpack_public_path__ + "img/hr-V-R-6-load-standup-shadow.817b1f83.png";